export default "__VITE_ASSET__Btt2adAI__"